import * as Sentry from '@sentry/nuxt';
import buildInfo from '@/app/version.json';

export const resolveSentryConfigShared = (sentryConfig: any) =>
  ({
    enabled: sentryConfig.enabled,

    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,

    release: buildInfo.imageTag,

    // Error sample rate
    sampleRate: sentryConfig.sampleRate ?? 1.0,

    // Trace sample rate
    tracesSampleRate: sentryConfig.tracesSampleRate ?? 0.05,

    // Set sampling rate for profiling (value is relative to tracesSampleRate)
    profilesSampleRate: sentryConfig.profilesSampleRate ?? 0.0,

    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api-dev.*\.os\.fressnapf\.com/,
      /^https:\/\/api-stage.*\.os\.fressnapf\.com/,
      /^https:\/\/api\.os\.fressnapf\.com/,
      /^\//,
      /rest\/v2/,
      /rest\/latest/,
    ],

    attachStacktrace: true,
    sendClientReports: false,
  }) satisfies Parameters<typeof Sentry.init>[0];
